import * as Types from '@frameio/graphql-client/generated/types';

import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
import gql from 'graphql-tag';

import { useQuery, useLazyQuery, useMutation, useFragment, useSubscription } from '@apollo/client';
import type { QueryHookOptions, LazyQueryHookOptions, MutationHookOptions, SubscriptionHookOptions, UseFragmentOptions } from '@apollo/client';

export type UpdateShareCardFitImageMutationVariables = Types.Exact<{
  shareId: Types.Scalars['ID']['input'];
  cardFitImage?: Types.InputMaybe<Types.Scalars['Boolean']['input']>;
}>;


export type UpdateShareCardFitImageMutation = { __typename?: 'Mutation', updateShare?: { __typename?: 'UpdateSharePayload', share?: { __typename?: 'AdHocAssetsShare', id: string, appearance: { __typename?: 'AssetAggregateAppearance', cardFitImage: boolean } } | { __typename?: 'CollectionShare', id: string, appearance: { __typename?: 'AssetAggregateAppearance', cardFitImage: boolean } } | null } | null };


export const UpdateShareCardFitImage = /*#__PURE__*/ gql`
    mutation UpdateShareCardFitImage($shareId: ID!, $cardFitImage: Boolean) {
  updateShare(
    input: {shareId: $shareId, appearance: {cardFitImage: $cardFitImage}}
  ) {
    share {
      id
      ... on AssetAggregate {
        appearance {
          cardFitImage
        }
      }
    }
  }
}
    ` as unknown as DocumentNode<UpdateShareCardFitImageMutation, UpdateShareCardFitImageMutationVariables>;

          

          export const useUpdateShareCardFitImageMutation = (options?:MutationHookOptions<UpdateShareCardFitImageMutation, UpdateShareCardFitImageMutationVariables>) => useMutation(UpdateShareCardFitImage, options);
          

          export type UpdateShareCardFitImageMutationOptions = MutationHookOptions<UpdateShareCardFitImageMutation, UpdateShareCardFitImageMutationVariables>;

          

          export type UpdateShareCardFitImageMutationResult = ReturnType<typeof useUpdateShareCardFitImageMutation>[1];

          
